import React, { useState, useCallback, useEffect } from "react";
import {
  Page,
  Card,
  Modal,
  Text,
  Spinner,
  Image,
  Loading,
  Button,
  DataTable,
  ButtonGroup,
  Toast,
  Checkbox,
  FormLayout,
  Filters,
  TextField,
  Badge,
  Frame,
  InlineError,
  ChoiceList,
  Thumbnail,
  EmptySearchResult,
  Select,
} from "@shopify/polaris";
import axios from "../../../Assets/Lib/axios";
import { useRef } from "react";
import emptyListImage from "../../../Assets/Images/emptyList.svg";
import { useNavigate } from "react-router-dom";
import { MultiSelect } from "react-multi-select-component";
import Pagination from "@mui/material/Pagination";
import { useParams } from "react-router-dom";
import moment from "moment";
import { capitalizeFirstLetter } from "../../../Helpers";
import { EditIcon } from "@shopify/polaris-icons";

const MembershipSubscribers = () => {
  const navigate = useNavigate();
  const { id, submembershipId } = useParams();
  const addEditState = useRef("");
  const perPage = 50;
  const [ts, setTs] = useState("");
  const [availability, setAvailability] = useState("");
  const [queryValue, setQueryValue] = useState("");
  const [page, setPage] = useState(1);
  const [pageObject, setPageObject] = useState({
    isLoading: true,
    isSaving: false,
    tableItems: [],
    tableTotalPages: 0,
    isListEmpty: false,
  });
  const handleAddItem = () => {
    navigate("/admin/memberships/new");
  };
  function handleFiltersQueryChange(queryValue) {
    refBoolPage.current = false;
    setQueryValue(queryValue);
  }
  function handleAvailabilityChange(availability) {
    setAvailability(availability);
  }
  const handleAvailabilityRemove = useCallback(() => setAvailability(""), []);
  const handleQueryValueRemove = useCallback(() => setQueryValue(""), []);
  const handleFiltersClearAll = useCallback(() => {
    handleAvailabilityRemove();
    handleQueryValueRemove();
  }, [handleAvailabilityRemove, handleQueryValueRemove]);

  const filters = [
    {
      key: "availability",
      label: "Filter by",
      filter: (
        <ChoiceList
          title="Filter by"
          titleHidden
          choices={[{ label: "Email", value: "email" }]}
          selected={availability || []}
          onChange={handleAvailabilityChange}
        />
      ),
      shortcut: false,
    },
  ];

  const appliedFilters = [];
  if (!isEmpty(availability)) {
    const key = "availability";
    appliedFilters.push({
      key,
      label: disambiguateLabel(key, availability),
      onRemove: handleAvailabilityRemove,
    });
  }
  const loadingMarkup = pageObject.isLoading ? <Loading /> : null;
  const emtyState = pageObject.isListEmpty ? (
    <div
      style={{
        display: "flex",
        justifyContent: "middle",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div style={{ width: "25%" }}>
        <Image src={emptyListImage}></Image>
      </div>
      <div className="mb-3">
        <Text variant="bodyLg" as="p">
          No results found
        </Text>
      </div>
      <br />
    </div>
  ) : (
    pageObject.isLoading && (
      <div className="spinnerContainer">
        <div className="vertical-center">
          <Spinner size="large" />
        </div>
      </div>
    )
  );
  const refBoolPage = useRef(true);
  const handleChangePage = (event, value) => {
    refBoolPage.current = true;
    setPage(value);
  };
  const handleEdit = (param, pivotId) => {
    window.open(
      `/admin/memberships/${id}/submemberships/${submembershipId}/subscribers/${param}/edit/${pivotId}`,
      "_blank"
    );
  };
  const handleSubpackages = (id) => {
    navigate(`/admin/memberships/${id}/submemberships`);
  };
  const handleSubscribers = (id) => {
    navigate(`/admin/memberships/${id}/subscribers`);
  };
  const [selectedStatus, setSelectedStatus] = useState("all");
  const handleSelectChangeStatus = (status) => {
    setSelectedStatus(status);
  };
  useEffect(() => {
    fetchData();
  }, [ts, availability, queryValue, page, selectedStatus]);
  const handleClickRow = (param, pivot) => {
    navigate(
      `/admin/memberships/${id}/submemberships/${submembershipId}/subscribers/${param}/details/${pivot}`
    );
  };
  async function fetchData() {
    let response = "";

    try {
      response = await axios.get(
        `/memberships/${id}/submemberships/${submembershipId}/subscribers?per_page=${perPage}&page=${
          refBoolPage.current ? page : 1
        }${
          queryValue
            ? `&filter[${
                availability === "" ? "email" : availability
              }]=${queryValue}`
            : ""
        }${
          selectedStatus !== "all"
            ? `&filter[user_submemberships.is_valid]=${selectedStatus}`
            : ""
        }`
      );
      setPageObject({
        ...pageObject,
        tableItems: response.data.data.data.map((item, index) => [
          <div
            className="clickableDiv"
            onClick={() => handleClickRow(item.id, item?.pivot?.id)}
          >
            {item?.id}
          </div>,
          <div
            className="clickableDiv"
            onClick={() => handleClickRow(item.id, item?.pivot?.id)}
          >
            {item?.first_name ? item?.first_name : "-"}
          </div>,
          <div
            className="clickableDiv"
            onClick={() => handleClickRow(item.id, item?.pivot?.id)}
          >
            {item?.last_name ? item?.last_name : "-"}
          </div>,
          <div
            className="clickableDiv"
            onClick={() => handleClickRow(item.id, item?.pivot?.id)}
          >
            {item?.birthday ? item.birthday : "-"}
          </div>,
          <div
            className="clickableDiv"
            onClick={() => handleClickRow(item.id, item?.pivot?.id)}
          >
            {item?.email ? item?.email : "-"}
          </div>,
          <div
            className="clickableDiv"
            onClick={() => handleClickRow(item.id, item?.pivot?.id)}
          >
            {item?.nationality ? item?.nationality : "-"}
          </div>,
          <div
            className="clickableDiv"
            onClick={() => handleClickRow(item.id, item?.pivot?.id)}
          >
            {item?.phone_number ? item?.phone_number : "-"}
          </div>,
          <div
            className="clickableDiv"
            onClick={() => handleClickRow(item.id, item?.pivot?.id)}
          >
            {item?.pivot && item?.pivot?.start_date
              ? item?.pivot?.start_date
              : "-"}
          </div>,
          <div
            className="clickableDiv"
            onClick={() => handleClickRow(item.id, item?.pivot?.id)}
          >
            {item?.pivot?.expiry_date ? item?.pivot?.expiry_date : "-"}
          </div>,
          <div
            className="clickableDiv"
            onClick={() => handleClickRow(item.id, item?.pivot?.id)}
          >
            {item?.pivot && item?.pivot?.status ? (
              <Badge tone={switchStatusColor(item.pivot.status)}>
                {capitalizeFirstLetter(item?.pivot?.status)}
              </Badge>
            ) : (
              "-"
            )}
          </div>,
          <div
            className="clickableDiv"
            onClick={() => handleClickRow(item.id, item?.pivot?.id)}
          >
            <Badge tone={item?.pivot?.is_valid ? "success" : "critical"}>
              {item?.pivot?.is_valid ? "Active" : "Inactive"}
            </Badge>
          </div>,
          <div
            className="clickableDiv"
            onClick={() => handleClickRow(item.id, item?.pivot?.id)}
          >
            {item?.pivot?.created_at
              ? moment(item?.pivot?.created_at).format("YYYY-MM-DD HH:mm:ss")
              : "-"}
          </div>,
          <ButtonGroup>
            <Button
              onClick={() => handleEdit(item.id, item.pivot?.id)}
              icon={EditIcon}
            >
              Edit
            </Button>
          </ButtonGroup>,
        ]),
        isLoading: false,
        isListEmpty: !response.data.data.data.length ? true : false,
        tableTotalPages: response.data.data.total,
      });
    } catch (error) {
      console.log(error);
    }

    // if (!featuresList.length)
    //   try {
    //     responseFeatures = await axios.get(`features`);
    //     setFeaturesList(
    //       responseFeatures.data.data.data.map((item, index) => {
    //         return {
    //           label: item.name,
    //           value: item.id,
    //         };
    //       })
    //     );
    //   } catch (error) {
    //     console.log(error);
    //   }
  }

  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const [toastContent, setToastContent] = useState(
    "This professor has been successfully deleted"
  );

  const toastMarkup = active ? (
    <Toast content={toastContent} onDismiss={toggleActive} />
  ) : null;
  const switchStatusColor = (param) => {
    switch (param) {
      case "pending":
        return `default`;
      case "confirmed":
        return `success`;
      case "cancelled":
        return `warning`;
      case "cancelled with no refund":
        return `warning`;
      case "failed":
        return `critical`;
      default:
        return "";
    }
  };
  const handleBook = () => {
    navigate(
      `/admin/memberships/${id}/submemberships/${submembershipId}/subscribers/book`
    );
  };
  return (
    <Page
      title="Subscribers"
      backAction={{
        onAction: () => navigate(`/admin/memberships/${id}/submemberships`),
      }}
      fullWidth
      primaryAction={
        <Button variant="primary" onClick={handleBook}>
          Book
        </Button>
      }
    >
      <Card padding="0">
        {loadingMarkup}
        <FormLayout>
          <Select
            label="Active / Inactive: "
            options={[
              { label: "All", value: "all" },
              { label: "Active", value: "1" },
              { label: "Inactive", value: "0" },
            ]}
            onChange={handleSelectChangeStatus}
            value={selectedStatus}
            labelInline
          />
          <Filters
            queryValue={queryValue}
            queryPlaceholder="Search..."
            filters={filters}
            appliedFilters={appliedFilters}
            onQueryChange={handleFiltersQueryChange}
            onQueryClear={handleQueryValueRemove}
            onClearAll={handleFiltersClearAll}
          />

          <DataTable
            columnContentTypes={["text", "text", "text", "text"]}
            headings={[
              <Text variant="bodyMd" as="p" fontWeight="medium">
                ID
              </Text>,
              <Text variant="bodyMd" as="p" fontWeight="medium">
                First Name
              </Text>,
              <Text variant="bodyMd" as="p" fontWeight="medium">
                Last Name
              </Text>,
              <Text variant="bodyMd" as="p" fontWeight="medium">
                Date of Birth
              </Text>,
              <Text variant="bodyMd" as="p" fontWeight="medium">
                Email
              </Text>,
              <Text variant="bodyMd" as="p" fontWeight="medium">
                Nationality
              </Text>,
              <Text variant="bodyMd" as="p" fontWeight="medium">
                Phone Number
              </Text>,
              <Text variant="bodyMd" as="p" fontWeight="medium">
                Start Date
              </Text>,
              <Text variant="bodyMd" as="p" fontWeight="medium">
                Expiry Date
              </Text>,
              <Text variant="bodyMd" as="p" fontWeight="medium">
                Status
              </Text>,
              <Text variant="bodyMd" as="p" fontWeight="medium">
                Active / Inactive
              </Text>,
              <Text variant="bodyMd" as="p" fontWeight="medium">
                Created at
              </Text>,

              <Text variant="bodyMd" as="p" fontWeight="medium"></Text>,
            ]}
            rows={pageObject.tableItems}
            verticalAlign="middle"
            increasedTableDensity
            footerContent={
              pageObject.tableItems?.length &&
              `Showing ${pageObject.tableItems.length} of ${pageObject.tableTotalPages} results`
            }
            hasZebraStripingOnData
            // truncate
          />
        </FormLayout>
        {emtyState}
        {Math.ceil(pageObject.tableTotalPages / perPage) >= 2 && (
          <div
            style={{
              paddingTop: "10px",
              textAlign: "center",
              paddingBottom: "10px",
            }}
          >
            <Pagination
              variant="outlined"
              count={Math.ceil(pageObject.tableTotalPages / perPage)}
              page={page}
              onChange={handleChangePage}
            />
            {/* <Pagination
              count={Math.ceil(pageObject.tableTotalPages / perPage)}
              page={page}
              onChange={handleChangePage}
              size="large"
            /> */}
          </div>
        )}

        {toastMarkup}
      </Card>
    </Page>
  );
  function disambiguateLabel(key, value) {
    switch (key) {
      case "taggedWith":
        return `Tagged with ${value}`;
      case "availability":
        return `Filter by ${value}`;
      default:
        return value;
    }
  }
  function isEmpty(value) {
    if (Array.isArray(value)) {
      return value.length === 0;
    } else {
      return value === "" || value == null;
    }
  }
  function getFirstNonNullValue(obj) {
    for (const value of Object.values(obj)) {
      if (value !== null) {
        return value;
      }
    }
    return null;
  }
};

export default MembershipSubscribers;
